import { api } from '@api/index'
import handleEnterPress from '@utils/handleEnterPress'
import React, { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import 'twin.macro'

interface Props {
  postUUID: number
}

const AdminPostReplyForm = ({ postUUID }: Props) => {
  const [replyContent, setReplyContent] = useState('')
  const queryClient = useQueryClient()

  const saveReplyMutation = useMutation(
    (content: string) => api.adminService.createReply(postUUID, content),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['PostReply', Number(postUUID)])
        setReplyContent('')
      },
    }
  )

  const handleChangeReplyInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setReplyContent(e.target.value)
  }

  const handleSaveReply = () => {
    saveReplyMutation.mutate(replyContent)
  }

  return (
    <div tw="flex w-full h-45 gap-20 mt-30">
      <input
        onKeyPress={(e) => handleEnterPress(e, handleSaveReply)}
        onChange={handleChangeReplyInput}
        tw="w-full h-full"
        type="text"
        className="input"
        placeholder="댓글을 입력해 주세요."
        value={replyContent}
      />
      <button
        onClick={handleSaveReply}
        type="button"
        tw="w-full max-w-100 text-15 px-10 h-full"
        className="button"
      >
        댓글작성
      </button>
    </div>
  )
}

export default AdminPostReplyForm
